import { Map } from 'leaflet';

export const removeGridCellsFromMap = (map: Map, gridLayerRef: React.MutableRefObject<null>) => {
    // If the zoom level is less than the minimum zoom level, remove all grid rectangles from the map
    //@ts-ignore
    gridLayerRef.current.eachLayer((rectangle) => rectangle.removeFrom(map));
};
